import { render, staticRenderFns } from "./ExcelUploadModal.vue?vue&type=template&id=060f750c"
import script from "./ExcelUploadModal.vue?vue&type=script&lang=js"
export * from "./ExcelUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports